import Decimal from 'decimal.js';
import { addDays, addMonths } from 'date-fns';

import { ISSUE_LTV } from './calculatorConfig';

// loan / collateral_value = ISSUE_LTV (50%)
// → collateral_btc = loan / (btcPrice * ISSUE_LTV)
export function loanToCollateralBtc(loan: Decimal, btcPrice: Decimal): Decimal {
  return loan.div(btcPrice.mul(ISSUE_LTV));
}

// inverse of the above
export function collateralBtcToLoan(collateralBtc: Decimal, btcPrice: Decimal): Decimal {
  return collateralBtc.mul(btcPrice).mul(ISSUE_LTV);
}

// Bullet repayment = principal + simple interest accrued over the period.
// Inlined here as a calc-specific copy of the widget's loanCalculations.getAmountDue
// so the calculator stays self-contained on the same Decimal type.
export function maturityRepayment(
  loan: Decimal,
  interestRate: Decimal,
  period: number
): Decimal {
  // Match the loan-request widget's day-count logic: T+7 issue, period months
  // to maturity, simple interest on (days / 365).
  const startDate = addDays(new Date(), 7);
  const maturityDate = addMonths(startDate, period);
  const daysToMaturity =
    (maturityDate.getTime() - startDate.getTime()) / (1000 * 3600 * 24);
  return loan
    .mul(interestRate)
    .div(100)
    .mul(daysToMaturity)
    .div(365)
    .plus(loan);
}
